
// @flow
export const VIEW_TYPE_SUM: 'sum' = 'sum';
export const VIEW_TYPE_QUANTITY: 'quantity' = 'quantity';
